/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Already_ExistsInputs */



/**
* | output |
* | --- |
* | "This email is already used in the building" |
*
* @param {Email_Already_ExistsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const email_already_exists = /** @type {((inputs?: Email_Already_ExistsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Already_ExistsInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("This email is already used in the building")
	return /** @type {LocalizedString} */ ("Cet email est déjà utilisé dans le bâtiment")
});